<template>
  <div>
    <CDataTable
      hover
      striped
      :items="items"
      :fields="fields"
      clickable-rows
      @row-clicked="rowClicked"
      :pagination="true"
      :sorter="pages<=1"
    >
      <template #image_url="data">
        <td>
          <img :src="data.item.image_url || pixel" class="list_image" />
        </td>
      </template>
      <template #edit="">
        <td>
          <CIcon name="cil-arrow-right" />
        </td>
      </template>
    </CDataTable>
    <CPagination
      v-if="pages > 1"
      align="center"
      :active-page="activePage"
      v-on:update:activePage="pageChanged"
      :pages="pages"
      :dots="false"
    />
  </div>
</template>

<script>
import { PIXEL } from '../../constants'

export default {
  name: 'CrawlErrorTable',
  props: {
    items: { type: Array, default: () => [] },
    activePage: { type: Number },
    pages: { type: Number },
  },
  data() {
    return {
      fields: [
        { key: 'podcast_id' },
        { key: 'image_url', label: '' },
        { key: 'title', _classes: 'font-weight-bold' },
        { key: 'error_count' },
        { key: 'date_last_error', label: 'Last error' },
        { key: 'errors' },
        { key: 'edit', label: ' ', sorter: false },
      ],
      pixel: PIXEL,
    }
  },
  methods: {
    rowClicked(item) {
      this.$router.push({ path: `/podcasts/podcasts/${item.podcast_id}` })
    },
    pageChanged(val) {
      this.$router.push({ query: { page: val } }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
    },
  },
}
</script>

<style>
.list_image {
  width: 36px;
  height: 36px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" class="c-sidebar-nav-icon"><path d="M5.192 5.192l-1.064-1.064c-0.005 0.004-0.009 0.009-0.014 0.013l-0 0c-2.023 2.023-3.275 4.818-3.275 7.905 0 3.071 1.238 5.852 3.243 7.873l-0.001-0.001 1.064-1.064c-1.734-1.746-2.805-4.152-2.805-6.808 0-2.679 1.090-5.104 2.852-6.854l0-0z"></path><path d="M19.925 4.141c-0.019-0.019-0.038-0.037-0.057-0.056l-1.064 1.064c1.788 1.755 2.895 4.197 2.895 6.897 0 2.666-1.080 5.080-2.825 6.828l0-0 1.064 1.064c2.015-2.022 3.261-4.811 3.261-7.892 0-3.087-1.251-5.882-3.274-7.905v0z"></path><path d="M7.196 7.196c-1.249 1.238-2.022 2.955-2.022 4.852 0 1.874 0.754 3.571 1.975 4.805l-0.001-0.001 1.060-1.060c-0.948-0.962-1.534-2.284-1.534-3.743 0-1.482 0.605-2.823 1.58-3.79l0-0z"></path><path d="M15.739 8.214c1.001 0.971 1.623 2.329 1.623 3.832 0 1.468-0.593 2.798-1.552 3.762l0-0 1.060 1.060c1.232-1.236 1.994-2.94 1.994-4.823 0-1.918-0.79-3.651-2.063-4.892l-0.001-0.001z"></path><path d="M13.817 10.136c-0.468-0.44-1.1-0.71-1.794-0.71-1.448 0-2.622 1.174-2.622 2.622s1.174 2.622 2.622 2.622c1.448 0 2.622-1.174 2.622-2.622 0-0 0-0 0-0v0c0-0.001 0-0.002 0-0.002 0-0.752-0.318-1.43-0.826-1.907l-0.001-0.001zM12.020 13.172c-0.621 0-1.125-0.504-1.125-1.125s0.504-1.125 1.125-1.125c0.621 0 1.125 0.504 1.125 1.125v0c0 0.621-0.504 1.125-1.125 1.125v0z"></path></svg>');
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: 16px 16px;
}
</style>
